<template>
    <div class="container q-py-sm" style="z-index: 9999!important">

        <div class="row items-center no-wrap justify-between">

            <div class="col-auto row items-center">
                <q-btn round size="md" color="primary" icon="notes" @click="$emit('rightDrawerToogle')"></q-btn>
            </div>

            <router-link to="/" class="logoLine">
                <img src="../../img/identity/logo-unitel.svg" :alt="appName" class="logo">
            </router-link>

            <div class="right-nav">
                <q-btn round size="md" color="primary" icon="search" class="search-btn" @click="$emit('rightDrawerToogle')"/>

                <social-sharing
                                title="check it out this news"
                                :quote="shareText"
                                :description="shareText"
                                hashtags="p4f,pocket4fun,g4m"
                                :url="home"
                                v-cloak inline-template>

                    <ul class="social">
                        <li class="social-item">
                            <network network="facebook" id="facebook">
                                <q-icon class="fab fa-facebook cursor-pointer"  style="color: white"/>
                            </network>
                        </li>

                        <li class="social-item">
                            <network network="twitter" id="twitter">
                                <q-icon class="fab fa-twitter cursor-pointer" style="color: white"/>
                            </network>
                        </li>

                        <li class="social-item">
                            <network network="whatsapp">
                                <q-icon class="fab fa-whatsapp cursor-pointer" style="color: white"/>
                            </network>
                        </li>

                    </ul>

                </social-sharing>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import {
        QBtn,
        QIcon,
        QPopover,
        QList,
        QItem,
        QSearch,
        QModal,
    } from 'quasar-framework'
    import Spinner from './spinner/Spinner'
    import axios from "axios";

    export default {
        data: () => ({
            appName: window.config.appName,
            showShare: true,
            home: `${config.appUrlPortal}/`,
            shareText: 'Consulta o melhor conteudo do Portal Unitel',
            shareUrl: 'https://www.instagram.com/unitelangola/',
        }),

        computed: {
            ...mapGetters({
                user: 'auth/user',
                menus: 'categories/user_categories'
            }),
        },

        components: {
            Spinner,
            QBtn,
            QIcon,
            QPopover,
            QList,
            QItem,
            QSearch,
            QModal,
        },
        mounted() {
            //this.getShareText();
        },
        methods: {
            getShareText() {
                axios.get(`${config.appUrl}/api/social-message`)
                    .then(({ data }) => {
                        this.shareText = data.share_text
                        this.shareUrl = data.share_url
                    })
                    .catch(error => {
                    })
            },
            async logout() {
                // Log out the user.
                await this.$store.dispatch('auth/logout')

                // Redirect to login.
                this.$router.push('/')
            },
        },
    }
</script>

<style lang="stylus" scoped>
    .right-nav
        display flex
        align-items center
        @media (max-width: 350px)
            magin 500px
    .search-btn
        padding 8px 5px 0 !important

    .logoLine
        @media (max-width: 350px)
            width 30%
    .logo
        @media (max-width: 350px)
            width 105%
    .social
        align-items baseline



</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Header.vue